import { ChevronLeft, ChevronRight } from "lucide-react";

import styles from "./Pagination.module.css";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
}
export const Pagination = ({
  currentPage,
  totalPages,
  setCurrentPage,
}: PaginationProps) => {
  const renderPagination = () => {
    const pages = [];
    const maxVisiblePages = 10;

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    // Previous button
    pages.push(
      <button
        key="prev"
        className={styles.navigationButton}
        onClick={() => setCurrentPage(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <ChevronLeft />
      </button>,
    );

    // First page
    if (startPage > 1) {
      pages.push(
        <button
          key={1}
          className={styles.pageNumberButton}
          onClick={() => setCurrentPage(1)}
        >
          1
        </button>,
      );

      if (startPage > 2) {
        pages.push(
          <div className={styles.paginationEllipsis}>
            <span key="ellipsis1">...</span>
          </div>,
        );
      }
    }

    // Page numbers
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          className={`${styles.pageNumberButton}${i === currentPage ? " bg-slate-600 text-white" : ""}`}
          onClick={() => setCurrentPage(i)}
        >
          {i}
        </button>,
      );
    }

    // Last page
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <div className={styles.paginationEllipsis}>
            <span key="ellipsis2">...</span>
          </div>,
        );
      }

      pages.push(
        <button
          key={totalPages}
          className={styles.pageNumberButton}
          onClick={() => setCurrentPage(totalPages)}
        >
          {totalPages}
        </button>,
      );
    }

    // Next button
    pages.push(
      <button
        key="next"
        className={styles.navigationButton}
        onClick={() => setCurrentPage(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <ChevronRight />
      </button>,
    );

    return pages;
  };
  return (
    <>
      {totalPages && (
        <div className="flex w-full p-4 align-middle justify-center">
          {renderPagination()}
        </div>
      )}
    </>
  );
};
